import React, { useCallback, useEffect, useState } from 'react';
import UIEventBus from '../EventBus';

interface MuteToggleProps { }

const MuteToggle: React.FC<MuteToggleProps> = ({ }) => {
    const [muted, setMuted] = useState(false);

    const onMouseDownHandler = useCallback(
        (event: React.MouseEvent) => {
            event.preventDefault();
            setMuted(!muted);
        },
        [muted]
    );

    useEffect(() => {
        UIEventBus.dispatch('muteToggle', muted);
    }, [muted]);

    return (
        <button
            className="macos-pill-button"
            onMouseDown={onMouseDownHandler}
            id="prevent-click"
            title={muted ? 'Unmute' : 'Mute'}
            style={{ border: 'none' }}
        >
            {muted ? <SpeakerOffIcon /> : <SpeakerOnIcon />}
        </button>
    );
};

const SpeakerOnIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2v6h4l5 4V5z" fill="rgba(255,255,255,0.85)" />
        <path d="M15.54 8.46a5 5 0 010 7.07" stroke="rgba(255,255,255,0.85)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M19.07 4.93a10 10 0 010 14.14" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const SpeakerOffIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2v6h4l5 4V5z" fill="rgba(255,255,255,0.85)" />
        <path d="M23 9l-6 6M17 9l6 6" stroke="rgba(255,80,80,0.85)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

export default MuteToggle;
